export default __webpack_public_path__ + "static/media/VickyLovelace.35e1b0b8.png";